<template>
  <ul class="grid-menu">
    <li v-for="item in items" :key="item.id">
      <a
        @click="onClick($event, item)"
        :target="item.isExternal ? '_blank' : null"
        v-bind:class="{
          external: item.isExternal,
          'close-panel': !item.children,
        }"
      >
        <div>
          <span
            class="icon"
            :class="getIconClass(item.iconId)"
            :style="{ color: iconColor }"
          >
          </span>

          <span class="text" :style="{ color: fontColor }"
            >{{ item.text }}</span
          >
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
import iconHelper from '../../helpers/menu.icon.helper'
export default {
  name: 'grid-items',
  props: {
    items: {
      type: Array,
      required: true,
      default: []
    },
    iconColor: {
      type: String
    },
    fontColor: {
      type: String
    }
  },
  methods: {
    getIconClass (iconId) {
      return iconHelper.getIconClassById(iconId)
    },
    onClick (e, item) {
      item.children && item.children.length
        ? this.$emit('onSelect', {event: e, data: item})
        : this.$emit('onClick', item)
    }
  }
}
</script>

<style scoped>
ul.grid-menu {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* align-items: end; */
}
ul.grid-menu > li {
  width: auto;
}
ul.grid-menu > li > a {
  display: block;
}
</style>



// WEBPACK FOOTER //
// grid-menu-items.component.vue?72275837